// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  firmId: __t.u64().primaryKey().name("firm_id"),
  key: __t.string(),
  name: __t.string(),
  civ: __t.string(),
  kind: __t.string(),
  stationKey: __t.string().name("station_key"),
  beltKey: __t.string().name("belt_key"),
  hulls: __t.u32(),
  hullsTarget: __t.u32().name("hulls_target"),
  shortHours: __t.u32().name("short_hours"),
  lastEpoch: __t.u64().name("last_epoch"),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
